export class ViewStateModel {
    showPanel: boolean;
    collapsePanel: boolean;
    showColumn: boolean;
}
